/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import { Feature, IpOnlyResponse } from 'client-code/fe-fav-service';
import { FeFavFilterServiceRepositoryImpl } from '../impls/FeFavFilterServiceRepositoryImpl';
import { IFeFavFilterServiceRepository } from '../interfaces/IFeFavFilterServiceRepository';
import { TServicesParams } from '../types/TServicesParams';

export class FeFavFilterService implements IFeFavFilterServiceRepository {
    private oFeFavFilterServiceRepository: FeFavFilterServiceRepositoryImpl;

    constructor(params: TServicesParams) {
        this.oFeFavFilterServiceRepository = new FeFavFilterServiceRepositoryImpl(params);
    }

    async ipOnly(): Promise<IpOnlyResponse> {
        return this.oFeFavFilterServiceRepository.ipOnly();
    }

    async fetchDeviceFeaturesFromService(): Promise<void> {
        return this.oFeFavFilterServiceRepository.fetchDeviceFeaturesFromService();
    }

    getDeviceFeatureByName(name: string): Feature {
        return this.oFeFavFilterServiceRepository.getDeviceFeatureByName(name);
    }
}
